import { render, staticRenderFns } from "./SectionScoreTable.vue?vue&type=template&id=6098f8fb&scoped=true&"
import script from "./SectionScoreTable.vue?vue&type=script&lang=js&"
export * from "./SectionScoreTable.vue?vue&type=script&lang=js&"
import style0 from "./SectionScoreTable.vue?vue&type=style&index=0&id=6098f8fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6098f8fb",
  null
  
)

export default component.exports